import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalBody,
  Form,
} from 'reactstrap';
import Footer from '../../components/footer/footer';
import Button from '../../components/buttons/primaryButton';
import Title from '../../components/title';
import { history } from '../../app/AppRouter';
import {
  //forgotPasswordApi,
  resetPassword,
  sendForgotEmail,
  changePassword,
  userInfoApi,
  userCardsApi,
  deleteUserCardsApi,
  addCardApi,
} from '../../redux/actions/api/apiAction';
// import { Formik, Form, Field, ErrorMessage } from "formik";
import { toastr } from 'react-redux-toastr';
//import Spinner from "../../components/spinner/spinner";
import { store } from '../../redux/storeConfig/store';
import uuid from 'react-uuid';
import moment from 'moment';
import * as Yup from 'yup';
import { withNamespaces } from 'react-i18next';

class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordinput: false,
      id: '',
      password: '',
      showPassword: false,
      otp: '',
      // oldPassword: "",
      newPassword: '',
      confirmPassword: '',
      showOldPassword: false,
      disableEditPasswordButton: false,
      cardToDeleteRID: '',
      deleteToggle: false,
      loading: false,
      cardCheckoutId: '',
    };
    this.toggle = this.toggle.bind(this);
  }
  async componentDidMount() {
    this.setState({
      id: JSON.parse(localStorage.getItem('connectToFitWebsiteUser')).gym,
    });
    this.props.userInfoApi();
    this.props.userCardsApi();
  }
  // toggle() {
  //   this.setState({
  //     passwordinput: !this.state.passwordinput,
  //   });
  // }
  async forgotClick() {
    let email = JSON.parse(localStorage.getItem('connectToFitWebsiteUser'))
      .email;
    let response = await this.props.sendForgotEmail(email);
    if (response) {
      this.toggle();
    } else {
      this.setState({ disable: false });
    }
  }
  change = async (e) => {
    e.preventDefault();
    if (this.state.newPassword && this.state.confirmPassword) {
      if (this.state.newPassword !== this.state.confirmPassword) {
        toastr.error('Password must be same!');
        return true;
      }
    }

    let email = JSON.parse(localStorage.getItem('connectToFitWebsiteUser'))
      .email;
    let datas = {
      email: email,
      password: this.state.newPassword,
      otp: this.state.otp,
    };
    await this.props.resetPassword(datas, false);
    history.push('/accountinfo');
  };

  otpClick = async (otp) => {
    this.setState({
      otp: otp,
      disableEditPasswordButton: false,
      passwordinput: true,
    });
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  deleteConfirmationToggle = () => {
    this.setState({ deleteToggle: !this.state.deleteToggle });
  };

  submitDeleteCard = async () => {
    this.setState((state) => {
      return { deleteToggle: !state.deleteToggle };
    });
    await this.props.deleteUserCardsApi(this.state.cardToDeleteRID);
    await this.props.userCardsApi();
  };

  addCardClick = async () => {
    let res = await this.props.addCardApi();
    if (res) {
      this.setState({ cardCheckoutId: res.id, loading: true });
    }
  };

  renderPaymentform = () => {
    const script2 = document.createElement('script');
    script2.innerHTML = `
      var wpwlOptions = {
        style: "card",
        locale:'${this.props.language}',
        paymentTarget: "_top",
        registrations: { requireCvv: true, hideInitialPaymentForms: true },
        maskCvv: true
      };
      `;
    document.body.appendChild(script2);

    const script = document.createElement('script');

    script.src = `https://oppwa.com/v1/paymentWidgets.js?checkoutId=${this.state.cardCheckoutId}`;
    script.async = true;

    document.body.appendChild(script);
    let cardForm = document.getElementById('cardForm');

    const form = document.createElement("form");
    form.action = "https://www.connecttofit.com/cardResult";
    form.setAttribute("class", "paymentWidgets");
    form.setAttribute("data-brands", "VISA MASTER");
    cardForm.appendChild(form);
  };
  componentWillUnmount = () => {
    this.removeCard();
  };

  removeCard = () => {
    if (window.wpwl !== undefined && window.wpwl.unload !== undefined) {
      window.wpwl.unload();
      let arrayScript = document.getElementsByTagName('SCRIPT');
      for (let i = 0; i < arrayScript.length; i++) {
        if (
          arrayScript[i].src.indexOf('static.min.js') !== -1 ||
          arrayScript[i].src.indexOf('paymentWidgets.js') !== -1
        ) {
          arrayScript[i].remove();
        }
      }
    }
    this.setState({ loading: false });
  };
  render() {
    var user = JSON.parse(localStorage.getItem('connectToFitWebsiteUser'));
    const formSchema = Yup.object().shape({
      oldPassword: Yup.string().required('Password is required'),
      newPassword: Yup.string().required('Confirm Password is required'),
    });

    return (
      <>
        <div className='account-info ctf-bg-sixth admin-card-block '>
          <div className='custom-container'>
            <div className='section'>
              <Row className='justify-content-center'>
                <Col md={12} lg={12} xl={9}>
                  <div className='bg-white card-panel'>
                    <div className='basic-info'>
                      <div className='info-title with-border'>
                        <Title
                          title={this.props.t('password')}
                          titlestyle=''
                          subtitlestyle='ctf-tx-secondary'
                        />
                      </div>
                      <div
                        className={
                          this.state.passwordinput ? 'd-none' : 'd-block'
                        }
                      >
                        <Row>
                          <Col md={12}>
                            <div className='input-remain-content mt-3'>
                              <p className='ctf-tx-secondary' type='password'>
                                {this.props.t('password_last_edit')}{' '}
                                {this.props.loginFlag
                                  ? moment(this.props.user.lastPassAt).format(
                                      'MMMM Do YYYY, h:mm:ss a'
                                    )
                                  : this.props.t('not-available')}
                              </p>
                              <h3 className='input-title py-2'>
                                {/* Dima Aburajab */}
                                {/* {this.state.newPassword} */}

                                {/* {this.state.password} */}
                              </h3>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div
                        className={`
                          mt-3 ${
                            this.state.passwordinput ? 'd-block' : 'd-none'
                          }`}
                      >
                        <Form onSubmit={this.change}>
                          <Row>
                            <Col md={6}>
                              <FormGroup className='custom-inputs with-icon'>
                                <Input
                                  type={
                                    this.state.showNewPassword
                                      ? 'text'
                                      : 'password'
                                  }
                                  name='Password'
                                  minLength={8}
                                  required={true}
                                  id='Password'
                                  placeholder={this.props.t('password')}
                                  onChange={(e) => {
                                    this.setState({
                                      newPassword: e.target.value,
                                    });
                                  }}
                                />

                                <Label for='Password' className=''>
                                  {this.props.t('password')}
                                </Label>
                                <div className='icons'>
                                  {this.state.showNewPassword ? (
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='29.773'
                                      height='27.693'
                                      viewBox='0 0 29.773 27.693'
                                      onClick={() => {
                                        this.setState({
                                          showNewPassword: false,
                                        });
                                      }}
                                    >
                                      <g
                                        id='Group_7703'
                                        data-name='Group 7703'
                                        transform='translate(-475 -217)'
                                      >
                                        <g
                                          id='eye'
                                          transform='translate(475 221)'
                                        >
                                          <g
                                            id='Group_5705'
                                            data-name='Group 5705'
                                            transform='translate(0 0)'
                                          >
                                            <g
                                              id='Group_5704'
                                              data-name='Group 5704'
                                              transform='translate(0 0)'
                                            >
                                              <path
                                                id='Path_1'
                                                data-name='Path 1'
                                                d='M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z'
                                                transform='translate(-159.84 -164.577)'
                                                fill='#17468f'
                                              />
                                              <path
                                                id='Path_2'
                                                data-name='Path 2'
                                                d='M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z'
                                                transform='translate(0 -74.667)'
                                                fill='#17468f'
                                              />
                                            </g>
                                          </g>
                                        </g>
                                        <rect
                                          id='Rectangle_1884'
                                          data-name='Rectangle 1884'
                                          width='36'
                                          height='2'
                                          rx='1'
                                          transform='translate(477 243.329) rotate(-47)'
                                          fill='#17468f'
                                        />
                                      </g>
                                    </svg>
                                  ) : (
                                    <svg
                                      id='eye'
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='29.773'
                                      height='20.3'
                                      viewBox='0 0 29.773 20.3'
                                      onClick={() => {
                                        this.setState({
                                          showNewPassword: true,
                                        });
                                      }}
                                    >
                                      <g
                                        id='Group_5705'
                                        data-name='Group 5705'
                                        transform='translate(0 0)'
                                      >
                                        <g
                                          id='Group_5704'
                                          data-name='Group 5704'
                                          transform='translate(0 0)'
                                        >
                                          <path
                                            id='Path_1'
                                            data-name='Path 1'
                                            d='M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z'
                                            transform='translate(-159.84 -164.577)'
                                            fill='#17468f'
                                          />
                                          <path
                                            id='Path_2'
                                            data-name='Path 2'
                                            d='M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z'
                                            transform='translate(0 -74.667)'
                                            fill='#17468f'
                                          />
                                        </g>
                                      </g>
                                    </svg>
                                  )}
                                </div>
                              </FormGroup>
                            </Col>

                            <Col md={6}>
                              <FormGroup className='custom-inputs with-icon'>
                                <Input
                                  type={
                                    this.state.showConfirmPassword
                                      ? 'text'
                                      : 'password'
                                  }
                                  // name="confirmpassword"
                                  // id="confirmpassword"
                                  // placeholder="Confirm Password"
                                  // onChange={(e) => {
                                  name='Password'
                                  minLength={8}
                                  required={true}
                                  id='Password'
                                  placeholder={this.props.t(
                                    'confirm_new_password'
                                  )}
                                  onChange={(e) => {
                                    this.setState({
                                      confirmPassword: e.target.value,
                                    });
                                  }}
                                />

                                <Label for='Password' className=''>
                                  {this.props.t('confirm_new_password')}
                                </Label>
                                <div className='icons'>
                                  {this.state.showConfirmPassword ? (
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='29.773'
                                      height='27.693'
                                      viewBox='0 0 29.773 27.693'
                                      onClick={() => {
                                        this.setState({
                                          showConfirmPassword: false,
                                        });
                                      }}
                                    >
                                      <g
                                        id='Group_7703'
                                        data-name='Group 7703'
                                        transform='translate(-475 -217)'
                                      >
                                        <g
                                          id='eye'
                                          transform='translate(475 221)'
                                        >
                                          <g
                                            id='Group_5705'
                                            data-name='Group 5705'
                                            transform='translate(0 0)'
                                          >
                                            <g
                                              id='Group_5704'
                                              data-name='Group 5704'
                                              transform='translate(0 0)'
                                            >
                                              <path
                                                id='Path_1'
                                                data-name='Path 1'
                                                d='M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z'
                                                transform='translate(-159.84 -164.577)'
                                                fill='#17468f'
                                              />
                                              <path
                                                id='Path_2'
                                                data-name='Path 2'
                                                d='M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z'
                                                transform='translate(0 -74.667)'
                                                fill='#17468f'
                                              />
                                            </g>
                                          </g>
                                        </g>
                                        <rect
                                          id='Rectangle_1884'
                                          data-name='Rectangle 1884'
                                          width='36'
                                          height='2'
                                          rx='1'
                                          transform='translate(477 243.329) rotate(-47)'
                                          fill='#17468f'
                                        />
                                      </g>
                                    </svg>
                                  ) : (
                                    <svg
                                      id='eye'
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='29.773'
                                      height='20.3'
                                      viewBox='0 0 29.773 20.3'
                                      onClick={() => {
                                        this.setState({
                                          showConfirmPassword: true,
                                        });
                                      }}
                                    >
                                      <g
                                        id='Group_5705'
                                        data-name='Group 5705'
                                        transform='translate(0 0)'
                                      >
                                        <g
                                          id='Group_5704'
                                          data-name='Group 5704'
                                          transform='translate(0 0)'
                                        >
                                          <path
                                            id='Path_1'
                                            data-name='Path 1'
                                            d='M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z'
                                            transform='translate(-159.84 -164.577)'
                                            fill='#17468f'
                                          />
                                          <path
                                            id='Path_2'
                                            data-name='Path 2'
                                            d='M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z'
                                            transform='translate(0 -74.667)'
                                            fill='#17468f'
                                          />
                                        </g>
                                      </g>
                                    </svg>
                                  )}
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>

                          <div className='action-wrapper blk-padding-y'>
                            <div className='action-inner-block'>
                              <div className='action-btn-block'>
                                {this.state.passwordinput ? (
                                  <div>
                                    <button
                                      className='btn-medium btn btn-transparent '
                                      type='button'
                                      onClick={() =>
                                        this.setState({ passwordinput: false })
                                      }
                                    >
                                      {this.props.t('cancel')}
                                    </button>
                                    <button
                                      className='btn-medium btn '
                                      type='submit'
                                      // onClick={this.change}
                                    >
                                      {this.props.t('save')}
                                    </button>
                                  </div>
                                ) : (
                                  //  { {!this.state.disable ?
                                  <button
                                    className='btn-medium btn '
                                    disabled={
                                      this.state.disableEditPasswordButton
                                    }
                                    onClick={() => {
                                      this.setState({
                                        disableEditPasswordButton: true,
                                      });
                                      this.forgotClick();
                                    }}
                                  >
                                    {this.props.t('edit_password')}
                                  </button>
                                  //                       {/* </button>:
                                  // <Spinner />
                                  // }}{' '}
                                  // }
                                )}
                              </div>
                            </div>
                          </div>
                        </Form>
                        {/* )}
                        </Formik> */}
                      </div>
                      <div className='action-wrapper blk-padding-y'>
                        <div className='action-inner-block'>
                          <div className='action-btn-block'>
                            {!this.state.passwordinput && (
                              <button
                                className='btn-medium btn '
                                disabled={this.state.disableEditPasswordButton}
                                onClick={() => {
                                  this.setState({
                                    disableEditPasswordButton: true,
                                  });
                                  this.forgotClick();
                                }}
                              >
                                {this.props.t('edit_password')}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="bg-white card-panel mt-3">
                    <div className="basic-info">
                      <div className="info-title with-border d-flex justify-content-between">
                        <Title
                          title={this.props.t("card_info")}
                          titlestyle=""
                          subtitlestyle="ctf-tx-secondary "
                        />
                        {!this.state.loading ? (
                          <button
                            className="btn-medium btn"
                            onClick={() => this.addCardClick()}
                          >
                            {this.props.t("add_card")}
                          </button>
                        ) : (
                          <button
                            className="btn-medium btn"
                            onClick={() => this.removeCard()}
                          >
                            {this.props.t("remove_card")}
                          </button>
                        )}
                      </div>
                      <div id="cardForm" className="mt-3">
                        {this.state.loading && this.renderPaymentform()}
                      </div>
                      <Row>
                        {this.props.cards.map((one, index) => {
                          return (
                            <Col md={4} sm={12}>
                              <div>
                                <div className="input-remain-content mt-3">
                                  <p
                                    className="ctf-tx-secondary"
                                    type="password"
                                  >
                                    {this.props.t("card_number")}
                                  </p>
                                  <h3 className="input-title py-2">{`******${one.last4Digits}`}</h3>
                                </div>
                                <div className="action-wrapper blk-padding-y">
                                  <div className="action-inner-block">
                                    <div className="action-btn-block">
                                      <div>
                                        <button
                                          className="btn-medium btn btn-transparent btn-danger"
                                          onClick={() => {
                                            this.setState({
                                              cardToDeleteRID: one.rId,
                                            });
                                            this.deleteConfirmationToggle();
                                          }}
                                        >
                                          {this.props.t("delete_card")}
                                        </button>
                                        {/* <button
                                className="btn-medium btn "
                                onClick={() => this.toggle()}
                              >
                                {this.props.t("edit_credit_card")}
                              </button> */}
                  {/* </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    </div>
                  </div>  */}
                </Col>
              </Row>
            </div>
          </div>
          <Modal
            isOpen={this.state.modal}
            toggle={() => {
              this.toggle();
              this.setState({ disableEditPasswordButton: false });
            }}
            centered={true}
            size='lg'
            className='large-pop delete-pop'
          >
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();

                  this.otpClick(e.target.otp.value);
                  this.toggle();
                }}
              >
                <div className='modal-body-content'>
                  <div className='content'>
                    <div className='delete-title'>
                      <h2 className=''>{this.props.t('forgot_password')}</h2>
                    </div>
                    <div className='delete-data'>
                      <h5>{this.props.t('forgot_pop_statement_1')}</h5>
                    </div>
                    <div className='pb-4'>
                      <Row className='justify-content-center'>
                        <Col md={6}>
                          <FormGroup className='custom-inputs mb-md-0'>
                            <Input
                              type='text'
                              name='otp'
                              id='otp'
                              required
                              placeholder={this.props.t('type_in_code')}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className='action-btn-block pt-2'>
                    <button
                      type='button'
                      // toggle={() => {
                      //   this.toggle();
                      //   this.setState({ disableEditPasswordButton: false  });
                      // }}
                      className='btn btn-small btn-transparent'
                      onClick={() => {
                        this.toggle();
                        this.setState({ disableEditPasswordButton: false });
                      }}
                    >
                      {this.props.t('cancel')}
                    </button>
                    <button
                      type='submit'
                      className=' btn btn-small btn-grey '
                      // onClick={this.toggle}
                    >
                      {this.props.t('check_code')}
                    </button>
                  </div>
                </div>
              </Form>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={this.state.deleteToggle}
            toggle={this.deleteConfirmationToggle}
            centered={true}
            size='md'
            className='small-pop delete-pop'
          >
            <ModalBody>
              <div className='modal-body-content'>
                <div className='content'>
                  <div className='delete-title'>
                    <h2 className=''>{this.props.t('delete_card')}</h2>
                  </div>
                  <div className='delete-data'>
                    <h5>{this.props.t('delete_card_statement')}</h5>
                  </div>
                </div>
                <div className='action-btn-block pt-2'>
                  <button
                    type='button'
                    // toggle={() => {
                    //   this.toggle();
                    //   this.setState({ disableEditPasswordButton: false  });
                    // }}
                    className='btn btn-small btn-transparent'
                    onClick={() => {
                      this.deleteConfirmationToggle();
                    }}
                  >
                    {this.props.t('cancel')}
                  </button>
                  <button
                    type='button'
                    className=' btn btn-small btn-grey '
                    onClick={this.submitDeleteCard}
                  >
                    {this.props.t('yes')}
                  </button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* <div className>
          <Footer></Footer>
        </div> */}
      </>
    );
  }
}
// const mapStateToProps = (state) => {
//   const { gyms, gym } = state.gymData;
//   return { gyms, gym };
// };
const mapStateToProps = (state) => {
  const { loginUser, loginFlag } = state.login;
  const { cards } = state.cards;
  const { user } = state.userData;
  const { language, direction } = state.languageDirectionData;
  return { loginUser, loginFlag, user, cards, language, direction };
};
export default connect(mapStateToProps, {
  changePassword,
  sendForgotEmail,
  resetPassword,
  userInfoApi,
  userCardsApi,
  deleteUserCardsApi,
  addCardApi,
})(withNamespaces()(Setting));
